import React, { useEffect, useState } from 'react';
import { getPostsFromCategory } from '../clientwrapper';
import { getAnimationParams } from '../utils/animationhelper';
import { motion } from 'framer-motion';
import Header from '../components/whatsnext/Header';
import Participate from '../components/whatsnext/Participate';
import YouCan from '../components/whatsnext/YouCan';
import { useTranslation } from 'react-i18next';

const WhatsNextPage = (props) => {
  const { refs } = props;
  const { t } = useTranslation();
  const [mounted, setMounted] = useState(true);
  const [texts, setTexts] = useState({});
  const animParams = getAnimationParams('page');
  const backLink = props.location.backLink ? props.location.backLink : 'individual';
  const backText = props.location.backText ? props.location.backText : t('whatsnext.backinidividual');

  useEffect(() => {
    const fetchData = async () => {
      const apiResult = await getPostsFromCategory(process.env.REACT_APP_CATEGORY_WHATSNEXT);
      const { data, success } = apiResult;
      if (success) {
        let filteredText = [];
        data.forEach((datatext) => {
          filteredText[datatext.title.rendered] = datatext;
        })
        setTexts(filteredText);
      }
    };
    if (mounted) {
      fetchData();
    }
    return () => { setMounted(false) }
  }, [mounted]);

  return (
    <motion.div
      transition={animParams['transition']}
      initial={animParams['initial']}
      animate={animParams['animate']}
      exit={animParams['animExit']}
      className="main-content"
    >
      <Header refs={refs} texts={texts['header']}></Header>
      <Participate refs={refs} texts={texts['participate']}></Participate>
      <YouCan refs={refs} texts={texts['youcan']} backLink={backLink} backText={backText}></YouCan>
    </motion.div>
  );
}

export default WhatsNextPage;